import React, { useState, useEffect } from 'react';
import { FaSearch, FaSlidersH, FaAngleDown } from 'react-icons/fa';
import { apiRequest } from '../PromptManagerTemplate/services/promptManagerService';
import { API_ENDPOINTS, HTTP_METHODS } from '../../constants/appConstants';
import { useAuth } from '../../contexts/AuthContext';

const WorkflowSortCategoriesToolbar = ({ onSearch, onSort }) => {
  const { token, handleLogout } = useAuth();
  const [savedCategories, setSavedCategories] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const savedCategoriesResponse = await apiRequest(
          API_ENDPOINTS.CATEGORY_LIST,
          HTTP_METHODS.POST,
          { deletedAt: 'null' },
          token,
          handleLogout
        );

        if (savedCategoriesResponse?.data) {
          // Replace with actual logic
          setSavedCategories(savedCategoriesResponse.data);
          console.log('Fetched categories:', savedCategoriesResponse.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const toSlug = (label) => {
    return label
      .toLowerCase() // make lowercase
      .replace(/\s+/g, '-') // replace spaces with dashes
      .replace(/[^\w-]+/g, ''); // remove non-word characters (optional)
  };

  const categoryOptions = [
    { value: '', label: 'All Categories' },
    ...savedCategories?.map((category) => ({
      value: toSlug(category.category_name),
      label: category.category_name,
    })),
  ];
  const [searchText, setSearchText] = useState('');
  const [sortOpen, setSortOpen] = useState(false);
  const [selectedCategoryOption, setSelectedCategoryOption] =
    useState('All Categories');

  const toggleSort = () => {
    setSortOpen(!sortOpen);
  };

  const handleSortChange = (value) => {
    const selectedOption = categoryOptions.find(
      (option) => option.value === value
    );

    setSelectedCategoryOption(selectedOption?.label || 'All Categories');
    setSortOpen(false); // Close dropdow
    onSort(value); // Trigger the sort logic
    setSortOpen(false);
  };

  return (
    <div style={{ display: 'flex', gap: '10px', padding: '0px' }}>
      {/* Search Box */}
      <div style={{ position: 'relative' }}></div>

      {/* Sort By Dropdown */}
      <div style={{ position: 'relative' }}>
        <button
          onClick={toggleSort}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            padding: '10px 15px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            cursor: 'pointer',
          }}
        >
          {selectedCategoryOption} <FaAngleDown style={{ color: '#A1A1A1' }} />
        </button>
        {sortOpen && (
          <div
            style={{
              position: 'absolute',
              top: '40px',
              right: '0',
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              borderRadius: '4px',
              boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
              zIndex: 100,
              textTransform: 'capitalize',
            }}
          >
            {categoryOptions.map((option) => (
              <div
                key={option.value}
                onClick={() => handleSortChange(option.value)}
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkflowSortCategoriesToolbar;
